import { createFileRoute } from "@tanstack/react-router";
import { heritageCityRoute } from "@/lib/seo/heritageCityRoute";

export const Route = createFileRoute("/heritage/jonkoping")(
  heritageCityRoute({
    citySlug: "jonkoping",
    angle:
      "I Jönköping och Gnosjöregionen finns en tät väv av ägarledda tillverkningsföretag där kunskap gått i arv inom familjen — och där både generationsskiften och livsberättelser blir aktuella samtidigt.",
    localUseCases: [
      "Kunskapsarv i ägarledda tillverkningsföretag",
      "Generationsskifte i Gnosjöregionens familjebolag",
      "Filmad livsberättelse med grundaren",
      "Dokumentation av tyst kunskap i verkstad och produktion",
      "Företagshistoria inför jubileum",
      "Minnesfilm till familjens högtidsdagar"
    ],
  }),
);
